import axios from 'axios'

const http = axios.create({
  // baseURL: process.env.VUE_APP_API_BASE_URL || '',
  timeout: 15000,
  headers: { 'X-Stradew-Request': '1' }
})

http.interceptors.request.use(
  (config) => config,
  (error) => Promise.reject(error)
)

http.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
)

const axiosPlugin = {
  install(app) {
    app.config.globalProperties.$axios = http
    app.provide('axios', http)
  }
}

export { http }
export default axiosPlugin
